import React, { useState } from 'react';
import StyledH6Heading from '../../../common/components/styledH6Heading/StyledH6Heading';
import StyledMdText from '../../../common/components/styledMdText/StyledMdText';
import StyledXsText from '../../../common/components/styledXsText/StyledXsText';
import Button from '../../../components/button/Button';
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import { useMintingStateContext } from "../../../context/CrowdfundingContext";
import { useStateContext } from "../../../context/StateContext";
import { Error } from '../../../components/toast/Error';
import { Success } from '../../../components/toast/Success';
import { useNavigate } from 'react-router-dom';
import { useAccount } from 'wagmi';

const AddProjectsSection = () => {
  const { createProject } = useMintingStateContext();
  const { isValid } = useStateContext();
  const account = useAccount();
  const navigate = useNavigate();

  const [projectData, setProjectData] = useState({
    _projectName: '',
    _projectDescription: '',
    _location: '',
    _targetTime: new Date(),
    _requiredFunds: '',
    facebook: '',
    twitter: '',
    instagram: '',
    socialLink: '',
    _tags: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === '_tags') {
      const tagsArray = value.split(',').map(tag => tag.trim());
      setProjectData({ ...projectData, _tags: tagsArray });
    } else {
      setProjectData({ ...projectData, [name]: value });
    }
  };

  const handleAddProject = async () => {
    if (!isValid) {
      Error({ text: "Failed!", message: "Please Connect Your Wallet or Switch Network" });
      return;
    }

    // Convert required funds to wei and ensure it's a string
    const requiredFundsInWei = (projectData._requiredFunds) * (10 ** 18).toString();

    const projectToSend = {
      ...projectData,
      _targetTime: Math.floor(new Date(projectData._targetTime).getTime() / 1000),
      _requiredFunds: requiredFundsInWei,
      _tags: projectData._tags,
    };

    try {
      const response = await createProject(projectToSend, account.address);
      if (response.transactionHash !== null) {
        Success({ text: "Success!", message: "Project added successfully" });
        navigate('/projects');
      }
      else {
        Error({ text: "Failed!", message: "Something went wrong!" });
      }
    } catch (error) {
      console.log("AddProject Error:", error);
      Error({ text: "Failed!", message: "Error adding project" });
    }
  };


  return (
    <div className='py-32 text-white w-[90%] flex flex-col items-center gap-10'>
      <div className='flex flex-col items-center gap-5'>
        <StyledH6Heading fontColor="text-gradient">Add A New Project</StyledH6Heading>
        <StyledMdText fontColor="text-white">Please fill in the details of your project below.</StyledMdText>
      </div>
      <div className='flex flex-col w-full p-10 shadow-2xl bg-opacity-20 bg-light-gray rounded-xl'>
        <div className='flex flex-col gap-5'>
          <div className='grid grid-cols-1 gap-5 md:grid-cols-2'>
            <div className='flex flex-col gap-2'>
              <StyledXsText>Project Name</StyledXsText>
              <input
                type='text'
                name='_projectName'
                placeholder='Enter Project Name'
                className='w-full p-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none'
                value={projectData._projectName}
                onChange={handleChange}
              />
            </div>
            <div className='flex flex-col gap-2'>
              <StyledXsText>Location</StyledXsText>
              <input
                type='text'
                name='_location'
                placeholder='Enter Location'
                className='w-full p-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none'
                value={projectData._location}
                onChange={handleChange}
              />
            </div>
            <div className='flex flex-col gap-2'>
              <StyledXsText>Required Funds</StyledXsText>
              <input
                type='number'
                name='_requiredFunds'
                placeholder='Enter Required Funds'
                className='w-full p-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none'
                value={projectData._requiredFunds}
                onChange={handleChange}
              />
            </div>
            <div className='flex flex-col gap-2'>
              <StyledXsText>Target Time</StyledXsText>
              <DateTimePicker
                onChange={(date) => setProjectData({ ...projectData, _targetTime: date })}
                value={projectData._targetTime}
                className='w-full p-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none'
              />
            </div>
          </div>
          <div className='flex flex-col gap-2'>
            <StyledXsText>Project Description</StyledXsText>
            <textarea
              name='_projectDescription'
              placeholder='Enter Project Description'
              className='w-full px-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none'
              value={projectData._projectDescription}
              onChange={handleChange}
            />
          </div>
          <div className='grid grid-cols-1 gap-5 md:grid-cols-2'>
            <div className='flex flex-col gap-2'>
              <StyledXsText>Facebook</StyledXsText>
              <input
                type='text'
                name='facebook'
                placeholder='Enter Facebook URL'
                className='w-full p-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none'
                value={projectData.facebook}
                onChange={handleChange}
              />
            </div>
            <div className='flex flex-col gap-2'>
              <StyledXsText>Twitter</StyledXsText>
              <input
                type='text'
                name='twitter'
                placeholder='Enter Twitter URL'
                className='w-full p-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none'
                value={projectData.twitter}
                onChange={handleChange}
              />
            </div>
            <div className='flex flex-col gap-2'>
              <StyledXsText>Instagram</StyledXsText>
              <input
                type='text'
                name='instagram'
                placeholder='Enter Instagram URL'
                className='w-full p-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none'
                value={projectData.instagram}
                onChange={handleChange}
              />
            </div>
            <div className='flex flex-col gap-2'>
              <StyledXsText>Social Link</StyledXsText>
              <input
                type='text'
                name='socialLink'
                placeholder='Enter Other Social Link'
                className='w-full p-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none'
                value={projectData.socialLink}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className='flex flex-col gap-2'>
            <StyledXsText>Tags</StyledXsText>
            <input
              type='text'
              name='_tags'
              placeholder='Enter Tags (comma separated)'
              className='w-full p-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none'
              value={projectData._tags.join(', ')}
              onChange={handleChange}
            />
          </div>
          <div className='flex justify-end'>
            <Button
              onClick={handleAddProject}
              variant="button-gradient"
              fontColor="flex items-center gap-3 justify-center text-md text-black"
            >
              Add Project
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProjectsSection;
